import { Bill } from '../../state/models';
import { get, httpDelete, post } from '../../utils/api';

const apiEndpoint = '/api/bills';

export async function loadById(billId: number): Promise<Bill> {
    return get<Bill>(`${apiEndpoint}/${billId}`);
}